import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import {
  isReference,
  Reference
} from '@apollo/client';
import _ from 'lodash';

import { DateTime } from 'luxon';
import { dateTimeFieldPolicy } from './fieldPolicies';
import { reactiveVariables } from 'modules/common/layer00';



export const Installation: ITypeSpecificPolicy<types.Installation> = {

  fields: {
    fullAreaName: {
      read: (existing, { readField }) => {
        const areaRef = <Reference>readField('area');
        let areaDisplayName = '';
        if (isReference(areaRef)) {
          areaDisplayName = readField<string>('displayName', areaRef) ?? '';
        }
        const subAreaRef = <Reference>readField('subArea');
        if (isReference(subAreaRef)) {
          const subAreaDisplayName = readField('displayName', subAreaRef);
          return `${areaDisplayName} ${subAreaDisplayName}`;
        }
      }
    },
    isOverDue: {
      read: (existing, { readField }) => {
        const decisions = readField<Reference[]>('decisions');

        const nonCompletedDecisionsDueSoon = decisions?.filter((node) => {
          const doesNotHaveDecision = readField('approved', node);

          const dueDate = readField<string>('dueDate', node);
          if (!dueDate) {
            return false;
          }

          const daysTillDueDate = DateTime.fromISO(dueDate).diffNow('days').days;

          const isPastDue = daysTillDueDate <= 0
            ? true
            : false;


          if (doesNotHaveDecision === null && isPastDue) {
            return true;
          }
          return false;
        }) ?? [];

        if (nonCompletedDecisionsDueSoon?.length < 1) {
          return false;
        }
        return true;
      }
    },
    isDueSoon: {
      read: (existing, { readField }) => {
        const decisions = readField<Reference[]>('decisions');

        const nonCompletedDecisionsDueSoon = decisions?.filter((node) => {
          const doesNotHaveDecision = readField('approved', node);

          const dueDate = readField<string>('dueDate', node);
          if (!dueDate) {
            return false;
          }

          const daysTillDueDate = DateTime.fromISO(dueDate).diffNow('days').days;

          const isDueSoon = daysTillDueDate <= 90 && daysTillDueDate >= 0
            ? true
            : false;


          if (doesNotHaveDecision === null && isDueSoon) {
            return true;
          }
          return false;
        }) ?? [];

        if (nonCompletedDecisionsDueSoon?.length < 1) {
          return false;
        }
        return true;
      }
    },

    isComplete: {
      read: (existing, {
        readField
      }) => {
        const decisions = readField<Reference[]>('decisions');

        const nonCompletedDecisions = decisions?.filter((node) => {
          const doesNotHaveDecision = readField('approved', node);

          if (doesNotHaveDecision === null) {
            return true;
          }
          return false;
        }) ?? [];

        if (nonCompletedDecisions?.length >= 1) {
          return false;
        }
        return true;
      }
    },
    plan: {
      read: (existing, { readField }) => {
        const plansFilter = reactiveVariables.filterPlansVar();
        if (!existing) {
          return existing;
        }
        if (!plansFilter.freeTextSearch) {
          return existing;
        }

        const rawName = readField<string | null>('name', existing);
        if (!rawName) {
          return null;
        }
        const name = _.toLower(rawName ?? '');
        const isMatch = name?.includes(_.toLower(plansFilter.freeTextSearch)) ? true : false;
        if (isMatch) {
          return existing;
        }
        return null;
      }
      // merge: true
    },
    endDate: dateTimeFieldPolicy(),
    estimatedStartDate: dateTimeFieldPolicy(),
    purchaseDate: dateTimeFieldPolicy(),
    startDate: dateTimeFieldPolicy()
  }
};
